module.exports = __webpack_public_path__ + "img/et-berry-emblems.cb27db79.webp";